module.exports = __webpack_public_path__ + "img/feature-hero-img-2.242c5ee3.svg";